var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            "show-confirm": false,
            width: 668,
            "append-to-body": "",
          },
          on: { open: _vm.open, "after-close": _vm.handleAfterClose },
          model: {
            value: _vm.showInputDialog,
            callback: function ($$v) {
              _vm.showInputDialog = $$v
            },
            expression: "showInputDialog",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form" },
            [
              _c("v-form-item", { attrs: { label: "版本ID", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.id) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "产品", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.product_name) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "软件版本", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.software_version) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "硬件版本", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.hardware_version) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "固件版本类型" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.version_typeshow) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "版本密码", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.version_secret) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "语言", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.language) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "企业名称", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.enterprise_name) + " "),
                ]),
              ]),
              _c(
                "v-form-item",
                { attrs: { label: "是否禁用云服务", prop: "" } },
                [
                  _c("span", { staticClass: "fileUrl" }, [
                    _vm._v(" " + _vm._s(_vm.row.disabled_cloudshow) + " "),
                  ]),
                ]
              ),
              _c("v-form-item", { attrs: { label: "系统", prop: "system" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.system) + " "),
                ]),
              ]),
              _c(
                "v-form-item",
                { attrs: { label: "发布日期", prop: "releaseDate" } },
                [
                  _c("span", { staticClass: "fileUrl" }, [
                    _vm._v(" " + _vm._s(_vm.row.created_at) + " "),
                  ]),
                ]
              ),
              _c("v-form-item", { attrs: { label: "固件地址", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(_vm._s(_vm.row.file_url)),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "固件hash码", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.file_hash) + " "),
                ]),
              ]),
              _c("v-form-item", { attrs: { label: "固件大小", prop: "" } }, [
                _c("span", { staticClass: "fileUrl" }, [
                  _vm._v(" " + _vm._s(_vm.row.image_size) + " byte "),
                ]),
              ]),
              _c(
                "v-form-item",
                {
                  staticClass: "description",
                  attrs: { label: "作者描述", prop: "" },
                },
                [
                  _c("span", { staticClass: "fileUrl" }, [
                    _vm._v(" " + _vm._s(_vm.row.author_description) + " "),
                  ]),
                ]
              ),
              _vm._l(_vm.row.descp_lang, function (item, index) {
                return _c(
                  "v-form-item",
                  {
                    key: index,
                    staticClass: "descp-language",
                    attrs: { prop: "descpSelect" },
                  },
                  [
                    _c(
                      "v-form-item",
                      {
                        staticClass: "description",
                        attrs: { prop: "change_log" },
                      },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", [
                            _vm._v("更新日志(" + _vm._s(item.language) + ")"),
                          ]),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.row.descp_lang[index].change_log) +
                            " "
                        ),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      {
                        staticClass: "description",
                        attrs: { prop: "new_func" },
                      },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", [
                            _vm._v("新功能(" + _vm._s(item.language) + ")"),
                          ]),
                        ]),
                        _vm._v(
                          " " + _vm._s(_vm.row.descp_lang[index].new_func) + " "
                        ),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      {
                        staticClass: "description",
                        attrs: { prop: "optimization" },
                      },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", [
                            _vm._v("优化内容(" + _vm._s(item.language) + ")"),
                          ]),
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(_vm.row.descp_lang[index].optimization) +
                            " "
                        ),
                      ],
                      2
                    ),
                    _c(
                      "v-form-item",
                      { staticClass: "description", attrs: { prop: "memo" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", [
                            _vm._v("备注(" + _vm._s(item.language) + ")"),
                          ]),
                        ]),
                        _vm._v(
                          " " + _vm._s(_vm.row.descp_lang[index].memo) + " "
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }